/**
 * colivIQ Brain product numbers (COL-527). Drafts unless marked "spec" —
 * Neel confirms them; change a value here, nowhere else.
 */
export const STALE_TICKET_DAYS = 14; // spec
export const ESCALATE_AFTER_DAYS = 10; // spec
export const KEY_PICKUP_SOON_DAYS = 3; // draft: move-in within 3 days, no handover
export const MOVEOUT_WINDOW_CLOSING_DAYS = 4; // draft: the move-out window is 14 days
export const LEASE_END_WINDOW_DAYS = 90; // draft
export const EMPTY_SOON_DAYS = 30; // draft: occupant's confirmed move-out within 30 days

/** How often every deck source (and the shared Brain state) re-reads: two minutes. */
export const BRAIN_POLL = {
  staleTime: 120_000,
  refetchInterval: 120_000,
} as const;
